import { Activity, Contact, ContactDetails, Document } from "./types";

export const contacts: Contact[] = [
  {
    id: '1',
    name: 'Sarah Johnson',
    initials: 'SJ',
    status: 'Prospect',
    title: 'VP of Operations',
    company: 'Acme Corp',
    email: 'sarah.j@acmecorp.com',
    phone: '+1 (555) 123-4567',
    dateAdded: '1/15/2025',
    lastTouchpoint: {
      type: 'WhatsApp',
      message: 'Discussed pricing',
      time: '2 days ago'
    },
    tags: ['Enterprise', 'High Priority'],
    avatarColor: 'bg-purple-500'
  },
  {
    id: '2',
    name: 'Michael Chen',
    initials: 'MC',
    status: 'Prospect',
    title: 'CTO',
    company: 'TechStart Inc',
    email: 'mchen@techstart.io',
    phone: '+1 (555) 234-5678',
    dateAdded: '1/20/2025',
    lastTouchpoint: {
      type: 'AI Call',
      message: 'Initial outreach',
      time: '1 day ago'
    },
    tags: ['Technology', 'Mid-Market'],
    avatarColor: 'bg-blue-500'
  },
  {
    id: '3',
    name: 'Jennifer Smith',
    initials: 'JS',
    status: 'Prospect',
    title: 'CEO',
    company: 'Global Solutions',
    email: 'j.smith@globalsolutions.com',
    phone: '+1 (555) 345-6789',
    dateAdded: '1/28/2025',
    lastTouchpoint: {
      type: 'AI Call',
      message: 'AI qualification call',
      time: 'Today'
    },
    tags: ['C-Level', 'Hot'],
    avatarColor: 'bg-indigo-500'
  },
  {
    id: '4',
    name: 'Robert Brown',
    initials: 'RB',
    status: 'Customer',
    title: 'Product Manager',
    company: 'Innovation Labs',
    email: 'rbrown@innovationlabs.com',
    phone: '+1 (555) 456-7890',
    dateAdded: '12/10/2024',
    lastTouchpoint: {
      type: 'Call',
      message: 'Product walkthrough',
      time: '3 days ago'
    },
    tags: ['Customer', 'Integrations'],
    avatarColor: 'bg-purple-600'
  },
  {
    id: '5',
    name: 'Emily Davis',
    initials: 'ED',
    status: 'Customer',
    title: 'Operations Director',
    company: 'Creative Agency',
    email: 'emily@creativeagency.com',
    phone: '+1 (555) 567-8901',
    dateAdded: '1/25/2025',
    lastTouchpoint: {
      type: 'Web Chat',
      message: 'Pricing inquiry',
      time: '3 hours ago'
    },
    tags: ['Customer', 'Design'],
    avatarColor: 'bg-blue-600'
  },
  {
    id: '6',
    name: 'David Martinez',
    initials: 'DM',
    status: 'Prospect',
    title: 'VP Sales',
    company: 'Enterprise Solutions',
    email: 'dmartinez@enterprisesolutions.com',
    phone: '+1 (555) 789-0123',
    dateAdded: '1/22/2025',
    lastTouchpoint: {
      type: 'Email',
      message: 'Requested demo',
      time: '5 hours ago'
    },
    tags: ['Enterprise'],
    avatarColor: 'bg-indigo-600'
  }
];

export const mockContact: ContactDetails = {
  id: '1',
  name: 'Sarah Johnson',
  initials: 'SJ',
  score: 0,
  status: 'Prospect',
  potentialDeal: 45000,
  title: 'VP of Operations',
  company: 'Acme Corp',
  email: 'sarah.j@acmecorp.com',
  phone: '+1 (555) 123-4567',
  website: 'acmecorp.com',
  location: 'San Francisco, CA',
  addedDate: '1/15/2025',
  tags: ['Enterprise', 'High Priority'],
  owner: 'Anshul Jain',
  leadSource: 'LinkedIn'
};

export const mockDocuments: Document[] = [
  {
    id: '1',
    name: 'ITR_AY_2024-25_Sarah_Johnson.pdf',
    uploadDate: '1/10/2025',
    size: '1.2 MB',
    uploadedBy: 'Anshul Jain',
    verified: true,
    fiscalYear: '2024-25'
  }
];

export const mockActivities: Activity[] = [
  {
    id: '1',
    type: 'email',
    title: 'Email sent',
    description: 'Product demo video and pricing information',
    user: 'Anshul Jain',
    timestamp: '10 minutes ago',
    attachmentCount: 2
  },
  {
    id: '2',
    type: 'whatsapp',
    title: 'WhatsApp conversation',
    description: 'Discussed pricing options and enterprise features',
    user: 'Anshul Jain',
    timestamp: '2 days ago',
    duration: '25 min',
    messageCount: 12
  },
  {
    id: '3',
    type: 'call',
    title: 'Phone call completed',
    description: 'Discovery call - 30 min',
    user: 'Anshul Jain',
    timestamp: '2 weeks ago',
    duration: '30 min'
  }
];